var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "类型",
      "prop": "payTo"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择付款对象后选择"
    },
    model: {
      value: _vm.formItem.paymentItem,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "paymentItem", $$v);
      },
      expression: "formItem.paymentItem"
    }
  }, _vm._l(_vm.paymentItemList, function (option) {
    return _c('Option', {
      key: option.item,
      staticStyle: {
        "width": "330px"
      },
      attrs: {
        "value": option.item
      }
    }, [_vm._v(_vm._s(option.zh))]);
  }), 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }